export const STRIPE_CONNECT_ACCOUNT_SURFACE_MIN_HEIGHT_CLASS = 'min-h-[200px]'
export const STRIPE_CONNECT_PAYOUT_SURFACE_MIN_HEIGHT_CLASS = 'min-h-[480px]'
export const STRIPE_CONNECT_ONBOARDING_SURFACE_MIN_HEIGHT_CLASS = 'min-h-[360px]'
export const STRIPE_CONNECT_ACTIVITY_SURFACE_MIN_HEIGHT_CLASS = 'min-h-[520px]'

export const STRIPE_CONNECT_ACCOUNT_SECTION = {
  title: 'Account Management',
  description:
    'Review public business details, support information, account settings, and banking details.',
  minHeightClassName: STRIPE_CONNECT_ACCOUNT_SURFACE_MIN_HEIGHT_CLASS,
}

export const STRIPE_CONNECT_PAYOUT_SECTION = {
  title: 'Payouts',
  description: 'Review your balance, payout schedule, and recent Stripe payouts.',
  minHeightClassName: STRIPE_CONNECT_PAYOUT_SURFACE_MIN_HEIGHT_CLASS,
}

export const STRIPE_CONNECT_ONBOARDING_SURFACE = {
  minHeightClassName: STRIPE_CONNECT_ONBOARDING_SURFACE_MIN_HEIGHT_CLASS,
}

export const STRIPE_CONNECT_DASHBOARDLESS_SECTIONS = {
  payments: {
    title: 'Payments',
    description: 'Review Stripe payment activity and payment details.',
    minHeightClassName: STRIPE_CONNECT_ACTIVITY_SURFACE_MIN_HEIGHT_CLASS,
  },
  disputes: {
    title: 'Disputes',
    description: 'Review disputes and submit evidence to Stripe.',
    minHeightClassName: STRIPE_CONNECT_ACTIVITY_SURFACE_MIN_HEIGHT_CLASS,
  },
  cardReaders: {
    title: 'Buy Card Readers',
    description: 'Buy card readers and accessories, and track your orders.',
    minHeightClassName: STRIPE_CONNECT_ACTIVITY_SURFACE_MIN_HEIGHT_CLASS,
  },
}

export const STRIPE_CONNECT_CARD_READER_SECTIONS = {
  shop: {
    title: 'Shop',
    description: 'Browse card readers and accessories, then check out.',
    minHeightClassName: STRIPE_CONNECT_ACTIVITY_SURFACE_MIN_HEIGHT_CLASS,
  },
  orders: {
    title: 'Orders',
    description: 'Track shipments and start returns or warranty claims.',
    minHeightClassName: STRIPE_CONNECT_ACCOUNT_SURFACE_MIN_HEIGHT_CLASS,
  },
}
